<script lang="ts">
	// Formating
	import { format } from 'svelte-i18n';
	//Design system
	import { Text, Input, Select } from '@Shelly/shelly-design-system';
	//Helpers
	import { valueOutOfRange } from 'src/helpers/utilities';
	import { capFirstChar } from 'src/helpers/utilities';
	//Types
	import type { VirtualComponentInterface } from 'src/types/VirtualComponents';

	export let settings: VirtualComponentInterface['config'],
		errorMaxLen = false;

	const min = 1;
	const max = 255;

	const viewOptions = [
		{
			title: capFirstChar(
				$format('virtual_component_label', {
					default: 'label',
				}),
			),
			value: 'label',
		},
		{
			title: capFirstChar(
				$format('virtual_component_label_field', {
					default: 'field',
				}),
			),
			value: 'field',
		},
		{
			title: capFirstChar(
				$format('virtual_component_image', {
					default: 'external source image URL',
				}),
			),
			value: 'image',
		},
		{
			title: capFirstChar(
				$format('virtual_component_label_hidden', {
					default: 'hidden',
				}),
			),
			value: '',
		},
	];

	$: errorMaxLen = valueOutOfRange(settings.max_len, min, max);
</script>

<Text styleType="h2" class="mb-s">
	{$format('virtual_component_title_view', {
		default: 'View',
	})}
</Text>
<Select
	aria-label={$format('select_component_view', {
		default: 'Select view',
	})}
	class="width-full mb-m"
	value={viewOptions.find((i) => i.value == settings?.meta?.ui?.view) || viewOptions[0]}
	options={viewOptions}
	icon="fas fa-eye"
	on:change={(e) => {
		settings.meta.ui.view = e.detail['value'];
	}}
	id="select-g0heuoa"
/>

<Text styleType="h2" class="mb-s">
	{$format('sub_settings_title_component_max_text_length', {
		default: 'Maximum Text Length',
	})}
</Text>
<Input
	aria-label={$format('input_component_max_length', {
		default: 'Input max length',
	})}
	size="m"
	class="mb-m"
	icon="fas fa-calculator"
	value={String(settings.max_len) || ''}
	on:input={(e) => (settings.max_len = Number(e.target['value']))}
	error={errorMaxLen
		? $format('min_max_error_description', {
				values: { min, max },
				default: 'Value must be between {min} and {max}.',
			})
		: ''}
	id="input-mapsfgl"
/>

<Text styleType="h2" class="mb-s">
	{$format('sub_settings_title_component_default_value', {
		default: 'Default Value',
	})}
</Text>
<Input
	aria-label={$format('input_component_default_value', {
		default: 'Input default value',
	})}
	size="m"
	class="mb-m"
	maxlength="255"
	icon="fas fa-edit"
	value={settings.default_value}
	on:input={(e) => (settings.default_value = e.target['value'])}
	id="input-6p9xmpc"
/>
